/* Glocke im Header: zeigt den roten Zähler verzögert nach dem Laden, merkt sich im Browser, welche Neuigkeiten schon geöffnet wurden. */

const STORAGE_KEY = 'kgroup:notifications-seen';

class KgNotifications extends HTMLElement {
  connectedCallback() {
    this.badges = [...document.querySelectorAll('[data-notification-badge]')];
    this.ids = this.dataset.ids || '';
    if (!this.badges.length || !this.ids) return;
    const dialog = document.getElementById(this.dataset.dialog);
    dialog?.addEventListener('dialog:open', () => this.markSeen());
    if (this.seen === this.ids) return;
    const show = () => {
      this.showTimer = setTimeout(() => {
        this.badges.forEach((badge) => {
          badge.hidden = false;
          badge.classList.add('is-visible');
        });
      }, 1200);
    };
    if (document.readyState === 'complete') show();
    else window.addEventListener('load', show, { once: true });
  }

  disconnectedCallback() {
    clearTimeout(this.showTimer);
  }

  get seen() {
    try {
      return localStorage.getItem(STORAGE_KEY) || '';
    } catch {
      return '';
    }
  }

  markSeen() {
    try {
      localStorage.setItem(STORAGE_KEY, this.ids);
    } catch {
      /* Speicher nicht verfügbar */
    }
    clearTimeout(this.showTimer);
    this.badges.forEach((badge) => {
      badge.classList.remove('is-visible');
      badge.hidden = true;
    });
  }
}

customElements.define('kg-notifications', KgNotifications);

/*
  Rabattcode anwenden: Der Code geht an den Warenkorb, der Schuber schliesst sich und
  unten erscheint derselbe Hinweis wie im Kaufbereich. Ohne JavaScript bleibt der
  Verweis auf /discount/CODE als Rueckfalloption, deshalb ist es ein Link geblieben.
*/
document.addEventListener('click', async (event) => {
  const link = event.target.closest('[data-notification-apply]');
  if (!link) return;
  const code = link.dataset.notificationApply.toUpperCase();
  event.preventDefault();
  if (link.hasAttribute('aria-busy')) return;
  link.setAttribute('aria-busy', 'true');
  const wurzel = window.Shopify?.routes?.root || '/';
  try {
    const warenkorb = await (await fetch(`${wurzel}cart.js`)).json();
    const andere = (warenkorb.discount_codes || [])
      .map((eintrag) => eintrag.code.toUpperCase())
      .filter((vorhanden) => vorhanden !== code);
    const drawer = document.querySelector('kg-cart');
    const abschnitte = drawer?.sectionId ? { sections: drawer.sectionId, sections_url: drawer.url } : {};
    const antwort = await fetch(`${wurzel}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: [...andere, code].join(','), ...abschnitte }),
    });
    if (!antwort.ok) throw new Error(String(antwort.status));
    const aktualisiert = await antwort.json();
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: aktualisiert, source: 'notification', sections: aktualisiert.sections },
      })
    );
    link.closest('kg-dialog')?.close();
    const warenkorbOeffnen = () => {
      const ziel = document.querySelector('kg-cart[data-drawer]');
      if (ziel?.open) ziel.open();
      else window.location.href = `${wurzel}cart`;
    };
    window.kgToast?.(link.dataset.appliedToast, link.dataset.cartLabel, warenkorbOeffnen, 6000);
  } catch {
    window.kgToast?.(link.dataset.errorToast);
  } finally {
    link.removeAttribute('aria-busy');
  }
});

/*
  Klick auf einen Rabattcode kopiert ihn und zeigt kurz einen Haken. Der Aktions-Block
  im Kaufbereich macht dasselbe, dessen Skript laeuft hier aber nicht mit.
*/
document.addEventListener('click', async (event) => {
  const knopf = event.target.closest('.notifications__code');
  if (!knopf) return;
  const text = knopf.querySelector('[data-promo-code-text]')?.textContent.trim();
  if (!text) return;
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    return;
  }
  knopf.setAttribute('data-copied', '');
  window.clearTimeout(knopf.timer);
  knopf.timer = window.setTimeout(() => knopf.removeAttribute('data-copied'), 1600);
});
